import React from 'react';
import './AuthButton.scss';

type AuthButtonProps = {
  style?: React.HTMLAttributes<HTMLDivElement>['style']
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type']
  id?: string
  color?: string
  disabled?: boolean
  onClick?: React.ButtonHTMLAttributes<HTMLButtonElement>['onClick']
  text: string | React.JSX.Element
}
const AuthButton = (props: AuthButtonProps) => (
  <div className="uscca-auth-btn" style={props.style}>
    <button
      type={props.type ? props.type : 'submit'}
      id={props.id}
      className={`btn ${props.color}`}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.text}
    </button>
  </div>
);

export default AuthButton;
